import React, { useContext } from "react";

const PGIModeContext = React.createContext();

export const usePGIMode = () => useContext(PGIModeContext);
export function ContextPGIMode({ children }) {
  const [mode, setMode] = React.useState(false);

  const handleChangeMode = (value) => {
    setMode(value);
  };

  const collection = {
    mode,
    handleChangeMode,
  };
  return (
    <PGIModeContext.Provider value={collection}>
      {children}
    </PGIModeContext.Provider>
  );
}
